import {ofType} from 'redux-observable'
import {ajax} from 'rxjs/ajax';
import {catchError, filter, map, mergeMap, switchMap} from 'rxjs/operators'
import {concat, of} from "rxjs";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import i18next from 'i18next';

import {store} from "../configureStore";
import {
    LOG_IN_REQUEST_SUCCESS,
    LOGOUT_REQUEST_SUCCESS,
    logoutRequestSuccess,
} from '../actions/Auth'
import {
    loadActiveShopAdministratorsRequestFail,
    loadActiveShopAdministratorsRequestSuccess,
    START_INITIALLY_LOADING_SHOPS,
    SHOPS_REQUEST_START,
    SHOPS_REQUEST_SUCCESS,
    SHOP_BY_ID_REQUEST_START,
    SHOP_BY_ID_REQUEST_SUCCESS,
    SHOPS_SELECT_SHOP,
    shopsRequestFail,
    shopsClearData,
    shopsRequestStart,
    shopsRequestSuccess,
    shopsSelectShop,
    updateCurrentShopAdministrator,
    shopByIdRequestStart,
    shopByIdRequestSuccess,
    shopByIdRequestFail,
    SHOPS_RELOAD_SHOP_START, shopsReloadShop, shopsReloadShopFail,
} from "../actions/Shops";
import {eventsLogEvent} from "../Components/utils";
import {EVENT_ADMIN_OPEN_APP} from "../constants";
import {receiveChatUpdate, receiveMessage, setWsConnected} from "../actions/Chats";


export const startInitiallyLoadingShopsEpic = (action$, state$) =>
    action$.pipe(
        ofType(START_INITIALLY_LOADING_SHOPS, LOG_IN_REQUEST_SUCCESS),
        filter(() => !state$.value.Shops.shopsAreInitiallyLoaded),
        map(
            action => {
                return shopsRequestStart();
            }
        )
    );

export const shopByIdRequestStartEpic = (action$, state$) =>
    action$.pipe(
        ofType(SHOPS_RELOAD_SHOP_START),
        switchMap(action => ajax.get(
                process.env.REACT_APP_API_URL + `shop/shops/${state$.value.Shops.activeShop.id}/`,
                {
                    Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                    'Content-Type': 'application/json',
                }
            ).pipe(
                map(response => {
                    if (response.response.status === 'ok') {
                        return shopsReloadShop(response.response.result);
                    } else {
                        return shopsReloadShopFail(response.response.result.errors);
                    }
                }),
                catchError(error => {
                    return of(shopByIdRequestFail({
                        'common': i18next.t('errors.common.request_sent', 'Error sending request'),
                    }));
                }),
            )
        ),
    );

export const reloadShopRequestStartEpic = (action$, state$) =>
    action$.pipe(
        ofType(SHOP_BY_ID_REQUEST_START),
        switchMap(action => ajax.get(
                process.env.REACT_APP_API_URL + `shop/shops/${action.id}/`,
                {
                    Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                    'Content-Type': 'application/json',
                }
            ).pipe(
                map(response => {
                    if (response.response.status === 'ok') {
                        return shopByIdRequestSuccess(response.response.result);
                    } else {
                        return shopByIdRequestFail(response.response.result.errors);
                    }
                }),
                catchError(error => {
                    return of(shopByIdRequestFail({
                        'common': i18next.t('errors.common.request_sent', 'Error sending request'),
                    }));
                }),
            )
        ),
    );

export const shopsRequestStartEpic = (action$, state$) =>
    action$.pipe(
        ofType(SHOPS_REQUEST_START),
        switchMap(action => ajax.get(
                process.env.REACT_APP_API_URL + `shop/shops/?limit=${400}${action.search ? "&search=" + action.search : ""}`,
                {
                    Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                    'Content-Type': 'application/json',
                }
            ).pipe(
                map(response => {
                    if (response.response.status === 'ok') {
                        if (!action.search && isEmpty(response.response.result.results)) {
                            return logoutRequestSuccess();
                        }
                        return shopsRequestSuccess(response.response.result.results);
                    } else {
                        return shopsRequestFail(response.response.result.errors);
                    }
                }),
                catchError(error => {
                    return of(shopsRequestFail({
                        'common': i18next.t('errors.common.request_sent', 'Error sending request'),
                    }));
                }),
            )
        ),
    );

// export const changeNatsSubscriptionEpic = (action$, state$) => {
//     const connectWithNats = (subscription) => {
//         const dataHandlers = {
//             messages: (data) => store.dispatch(receiveMessage(data)),
//             chats: (data) => store.dispatch(receiveChatUpdate(data))
//         };
//         const onNatsSubChange = (isConnected, natsConnection = false) => {
//             store.dispatch(setWsConnected(isConnected));
//         }
//         return state$.value.Plugins.nats.changeSettingsAndConnect(subscription, dataHandlers, onNatsSubChange)
//     }
//     return action$.pipe(
//         ofType(SHOPS_SELECT_SHOP),
//         switchMap(
//             () => {
//
//                 if (!state$.value.Shops.activeShop.nats_jwt || !state$.value.Shops.activeShop.nats_seed) {
//                     return ajax.get(
//                         process.env.REACT_APP_API_URL + `shop/shop_nats_tokens/${state$.value.Shops.activeShop.id}/`,
//                         {
//                             Authorization: `Bearer  ${state$.value.Auth.authToken}`,
//                             'Content-Type': 'application/json',
//                         }
//                     ).pipe(
//                         map(response => {
//                             if (response.response?.nats_jwt && response.response?.nats_seed) {
//                                 const subscription = {
//                                     shop_id: state$.value.Shops.activeShop.id,
//                                     nats_jwt: response.response.nats_jwt,
//                                     nats_seed: response.response.nats_seed
//                                 }
//                                 return connectWithNats(subscription)
//                             }
//                         }))
//                 } else {
//
//                     const subscription = {
//                         shop_id: state$.value.Shops.activeShop.id,
//                         nats_jwt: state$.value.Shops.activeShop.nats_jwt,
//                         nats_seed: state$.value.Shops.activeShop.nats_seed
//                     }
//
//                     return connectWithNats(subscription)
//                 }
//             }
//         ),
//         map(socket => {
//             return setWsConnected(!!socket)
//         })
//     );
// }

export const shopByIdRequestSuccessEpic = (action$, state$) =>
    action$.pipe(
        ofType(SHOP_BY_ID_REQUEST_SUCCESS),
        filter(() => state$.value.Shops.activeShop === undefined),
        map(action => {
            return shopsSelectShop(action.shop);
        })
    );

export const shopsRequestSuccessEpic = (action$, state$) =>
    action$.pipe(
        ofType(SHOPS_REQUEST_SUCCESS),
        filter(() => state$.value.Shops.activeShop === undefined),
        map(action => {
            const path = store.getState().router.location.pathname;
            const pathShop = path.match(/^\/(\d+)\//);
            const pathShopId = pathShop ? parseInt(pathShop[1]) : undefined;
            const selectedShop = find(action.shops, {id: pathShopId}) || action.shops[0];

            return shopsSelectShop(selectedShop);
        })
    );

export const shopsClearDataEpic = (action$, state$) =>
    action$.pipe(
        ofType(LOGOUT_REQUEST_SUCCESS),
        map(shopsClearData)
    );


export const loadShopAdministratorEpic = (action$, state$) =>
    action$.pipe(
        ofType(SHOPS_SELECT_SHOP),
        switchMap(
            action => ajax.get(
                process.env.REACT_APP_API_URL + `shop/shop_administrators/?shop_id=${action.shop.id}&is_active=true`,
                {
                    Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                    'Content-Type': 'application/json',
                }
            ).pipe(
                mergeMap(response => {
                    const currentShopAdministrator = find(
                        response.response.result.results,
                        ['profile.user.id', state$.value.Auth.user.id]
                    );

                    eventsLogEvent(EVENT_ADMIN_OPEN_APP, {});

                    return concat(
                        of(loadActiveShopAdministratorsRequestSuccess(response.response.result.results)),
                        of(updateCurrentShopAdministrator(currentShopAdministrator)),
                    );
                }),
                catchError(error => {
                    return of(loadActiveShopAdministratorsRequestFail({
                        'common': i18next.t('errors.common.request_sent', 'Error sending request')
                    }));
                }),
            )
        ),
    );
